import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

export function useWalletGracePeriod() {
	const { t } = useTranslation("wallet-grace-period");
	const rootStore = useRootAppStore();

	if (rootStore == null) {
		throw Error("should be used in components");
	}

	const offlineUser = rootStore.userAuthStore.shopUser;
	const onlineUser = rootStore.userAuthStore.onlineUser;

	const expirationDateString =
		offlineUser?.userAccountDeactivationGracePeriodExpirationDate ||
		onlineUser?.userAccountDeactivationGracePeriodExpirationDate;

	if (!expirationDateString) {
		return null;
	}

	const expirationDate = DateTime.fromISO(expirationDateString);
	const now = DateTime.now();
	const isExpired = expirationDate < now;

	let message: string;

	if (isExpired) {
		message = t("GRACE_PERIOD_EXPIRED");
	} else {
		const formattedDate = expirationDate.toLocaleString(
			DateTime.DATETIME_MED
		);
		message = t("GRACE_PERIOD_ACTIVE", {
			expirationDate: formattedDate,
		});
	}

	return {
		message,
		isExpired,
	};
}
